import React from 'react';
import styled from 'styled-components';
import { EditorDeclarativeBlock } from '@/webapi/use-experience-api';
import { ChangeScreenshot } from '@/utils/change-screenshot';
import { MoveChange } from '@/pkg/sdk';
import { conditional } from '@/utils/conditional';
import { SelectorSection } from '../components/selector-section';

interface MoveActionTitleProps {
  change: EditorDeclarativeBlock;
  screenshot: ChangeScreenshot;
}

export function MoveActionTitle({ change, screenshot }: MoveActionTitleProps) {
  const { htmlKind } = change.block.value as MoveChange;

  if (change?.hint) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{change.hint}</>;
  }

  return (
    <>
      Moving:{` `}
      <SelectorSection
        image={screenshot.mountUrl}
        editorId={change.editorId}
        selector={change.block.selector}
      />
      {` `}
      <Directive>
        {conditional(
          `instead of`,
          htmlKind === `appendBefore`,
          `before`,
          htmlKind === `appendAfter`,
          `after`,
        )}
      </Directive>
      <SelectorSection
        image={screenshot.changeUrl}
        editorId={change.editorId}
        selector={(change.block.value as MoveChange).destSelector}
      />
    </>
  );
}

const Directive = styled.span`
  color: #8e969d;
  text-transform: lowercase;
  margin-right: 0.3rem;
`;
